import { render, staticRenderFns } from "./SubscriptionPaymentItem.vue?vue&type=template&id=0ddf12ce&scoped=true&"
import script from "./SubscriptionPaymentItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPaymentItem.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPaymentItem.vue?vue&type=style&index=0&id=0ddf12ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf12ce",
  null
  
)

export default component.exports